<template>
  <transition name="modal-fade">
    <div id="modalEditBanner" class="dibble-modal modal-account-verification" style="z-index: 9999">
      <div class="modal small-m">
        <div
          class="modal-dialog modal-form "
          role="document"
          style="width: 600px"
        >
          <div class="modal-content" style="min-width: 600px !important;" v-if="userData">
            <div class="modal-header">
              <p class="title-modal">
                <span v-if="isVerified">
                  Account Verification
                </span>
                <span v-else v-text="!userData.is_phone_verified ? 'Verify Phone Number' : 'Verify Email'" />
              </p>
              <button
                type="button"
                data-dismiss="modal"
                aria-label="Close"
                @click="closeModal"
              >
              <img src="@/assets/images/close-dialog.svg" alt="close-icon">
              </button>
            </div>
            <div class="modal-body form-box mt-2">
              <div v-if="isLoadingData">Loading Data...</div>
              <div v-else class="user-modal-content" style="overflow: hidden">
                <div>
                  <div class="row" v-if="isVerified">
                    <div class="col-md-12 text-center strong-text">
                      <i class="fa fa-check-circle text-primary" />
                      <span class="ml-2">Your account is verified</span>
                    </div>
                  </div>
                  <div v-else>
                    <div class="row" v-if="!userData.is_phone_verified">
                      <div class="col-md-4 text-left">
                          <SelectField
                              v-model="userData.country_code"
                              name="country_code"
                              rules="required"
                              :options="countries"
                              :has-icon="true"
                              :has-shadow="true"
                          >
                              <template #append-icon>
                                  <a @click.prevent="() => {}">
                                      <i
                                          class="fa fa-chevron-circle-down mt-2"
                                          style="font-size: 20px; color: #40b8dc"
                                      />
                                  </a>
                              </template>
                          </SelectField>
                      </div>
                      <div class="col-md-8">
                        <TextField
                            v-model="userData.phone_num"
                            name="phone_num"
                            :has-shadow="true"
                        />
                      </div>
                    </div>
                    <div class="row" v-else-if="!userData.is_email_verified">
                      <div class="col-md-12">
                        <TextField
                            v-model="userData.email"
                            name="email"
                        />
                      </div>
                    </div>
                    <div class="row text-center">
                      <div class="col-md-12">
                        <p>
                          <button v-text="'Send Code'"
                                  :disabled="isCodeSent"
                                  class="btn-dialog btn-sm ok-btn mr-2 float-none" @click="sendVerificationCode">
                          </button>
                        </p>
                        <div class="mt-2 text-center" v-if="isCodeSent">
                          <span v-if="intervalResendCode > 0"> Resend code in {{ intervalResendCode }}s</span>
                          <a v-else href="javascript:;" class="text-secondary" @click="resendCode">
                            Resend code now
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row text-center" v-if="!isVerified">
                    <div class="col-md-12">
                      <div class="mt-4">
                        <p class="text-center">
                          Enter the 6-digit code we've sent you
                        </p>
                        <div class="d-flex justify-content-center">
                          <div class="form-box otp-input-wrap">
                            <input
                              ref="otp1"
                              :disabled="!isCodeSent"
                              v-model="otpCode[1]"
                              @keydown="handleKeyDown($event, 1)"
                              type="text" maxlength="1" id="otp" placeholder="" class="otp-input" />
                          </div>
                          <div class="form-box ml-2 otp-input-wrap">
                            <input
                              ref="otp2"
                              :disabled="!isCodeSent"
                              @keydown="handleKeyDown($event, 2)"
                              v-model="otpCode[2]" type="text" maxlength="1" id="otp" placeholder="" class="otp-input" />
                          </div>
                          <div class="form-box ml-2 otp-input-wrap">
                            <input
                              ref="otp3"
                              :disabled="!isCodeSent"
                              @keydown="handleKeyDown($event, 3)"
                              v-model="otpCode[3]" type="text" maxlength="1" id="otp" placeholder="" class="otp-input" />
                          </div>
                          <div class="form-box ml-2 otp-input-wrap">
                            <input
                              ref="otp4"
                              :disabled="!isCodeSent"
                              @keydown="handleKeyDown($event, 4)"
                              v-model="otpCode[4]" type="text" maxlength="1" id="otp" placeholder="" class="otp-input" />
                          </div>
                          <div class="form-box ml-2 otp-input-wrap">
                            <input
                              ref="otp5"
                              :disabled="!isCodeSent"
                              @keydown="handleKeyDown($event, 5)"
                              v-model="otpCode[5]" type="text" maxlength="1" id="otp" placeholder="" class="otp-input" />
                          </div>
                          <div class="form-box ml-2 otp-input-wrap">
                            <input
                              ref="otp6"
                              :disabled="!isCodeSent"
                              @keydown="handleKeyDown($event, 6)"
                              v-model="otpCode[6]" type="text" maxlength="1" id="otp" placeholder="" class="otp-input" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div class="d-flex justify-content-center mt-2" v-if="!isVerified">
                  <button v-text="'Verify'" v-if="userData"
                          :disabled="!isCodeSent || !codeEntered"
                          class="btn-dialog btn-sm ok-btn mr-2" @click="performVerificationOtp">
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>

import DibbleJS from "@/dibble";
import DibbleAPI from "@/api";
import TextField from "@/commons/FormElements/TextField.vue";
import DibbleJs from "@/dibble";
import DibbleApi from "@/api";
import {EventBus} from "@/utils/event-bus";
import SelectField from "@/commons/FormElements/SelectField.vue";

export default {
  name: "ModalVerifyProgress",
    components: {SelectField, TextField},
	props: {
		userId: String
	},
  data() {
    return {
      userData: null,
      isLoadingData: false,

      intervalResendCode: 30,
      isCodeSent: false,
      otpCode: {
        1: '',
        2: '',
        3: '',
        4: '',
        5: '',
        6: '',
      },

      mapFields: [
        "first_name",
        "last_name",
        "email",
        "phone_number",
        "birthdate",
        "alt_phone_number",
        "emergency_phone_number",
        "street_address",
        "city",
        "state",
        "zip_code",
        "country"
      ],
      dropDownFields: ["state", "country"],
      form: {
        first_name: "",
        last_name: "",
        email: "",
        phone_number: "",
        birthdate: "",
        alt_phone_number: "",
        emergency_phone_number: "",
        street_address: "",
        city: "",
        state: "",
        zip_code: "",
        country: ""
      },
      states: [],
      countries: []
    };
  },
  created() {
    this.getCountry();
  },
  computed: {
    codeEntered() {
      let isEntered = true;
      for (let i = 1; i <= 6; i++) {
        if (!this.otpCode[i]) {
          isEntered = false;
          break;
        }
      }

      return isEntered;
    },
    isVerified() {
      return this.userData && this.userData.is_phone_verified && this.userData.is_email_verified;
    },
    factorType() {
      return this.userData && this.userData.is_phone_verified ? 'EMAIL' : 'PHONE';
    }
  },
  watch: {
    otpCode: {
      handler: function (val) {
        if (val[6]) {
          this.$refs.otp6.blur();
        } else if (val[5]) {
          this.$refs.otp6.focus();
        } else if (val[4]) {
          this.$refs.otp5.focus();
        } else if (val[3]) {
          this.$refs.otp4.focus();
        } else if (val[2]) {
          this.$refs.otp3.focus();
        } else if (val[1]) {
          this.$refs.otp2.focus();
        }
      },
      deep: true,
    },
  },
  methods: {
      getCountry() {
          this.isLoadingData = true;
          DibbleJS.showLoader()
          DibbleJS.callApiRequest({
              '#request': DibbleAPI.api.getCountryCodes,
          }, (response) => {
              DibbleJS.hideLoader()
              if (DibbleAPI.isResponseSuccess(response)) {
                  this.countries = response.countries.map((item) => ({
                      value: item.country_code.toUpperCase(),
                      label: `+ ${item.dialing_code} (${item.name})`,
                      show_label: `+ ${item.dialing_code} (${item.country_code})`,
                  }));
                  this.getUserData()
              }
          })
    },
    getUserData() {
      DibbleJS.showLoader()
      DibbleJS.callApiRequest({
        '#request': DibbleAPI.api.getMyAuthDetails,
      }, (response) => {
        DibbleJS.hideLoader()
        this.isLoadingData = false;
        if (DibbleAPI.isResponseSuccess(response)) {
          this.userData = response
        } else {
          this.closeModal()
          DibbleJS.toastErrorMessage(response.message)
        }
      }, this._onRequestFailed)
    },
    sendVerificationCode() {
      DibbleJs.showLoader();
      const data = {
        '#request': DibbleApi.api.accountSendOtpCode,
        factor_type: this.factorType,
      };

      if (this.factorType === 'PHONE') {
        data['phone_num'] = this.userData.phone_num
        data['country_code'] = this.userData.country_code
      }

      if (this.factorType === 'EMAIL') {
        data['email'] = this.userData.email
      }

      DibbleJs.callApiRequest(data, (responseData) => {
        if (DibbleApi.isResponseSuccess(responseData)) {
          DibbleJs.toastSuccessMessage(
            'Verification code sent successfully'
          );

          this.isCodeSent = true;
          this.startResendCodeInterval();

          setTimeout(() => {
            this.$refs.otp1.focus();
          }, 500);
        } else {
          DibbleJs.toastErrorMessage(responseData.message);
        }
        DibbleJs.hideLoader();
      });
    },
    startResendCodeInterval() {
      this.intervalResendCode = 30;
      const interval = setInterval(() => {
        if (this.intervalResendCode > 0) {
          this.intervalResendCode--;
        } else {
          clearInterval(interval);
        }
      }, 1000);
    },
    resendCode() {
      DibbleJs.showLoader();
      const data = {
        '#request': DibbleApi.api.accountReSendOtpCode,
        factor_type: this.factorType,
      };
      DibbleJs.callApiRequest(data, (responseData) => {
        if (DibbleApi.isResponseSuccess(responseData)) {
          DibbleJs.toastSuccessMessage(
            'Verification code sent successfully'
          );

          this.otpCode = {
            1: '',
            2: '',
            3: '',
            4: '',
            5: '',
            6: '',
          };
          this.$refs.otp1.focus();
          this.startResendCodeInterval();
        } else {
          DibbleJs.toastErrorMessage(responseData.message);
        }
        DibbleJs.hideLoader();
      });
    },
    performVerificationOtp() {
      const code = [];
      for (let i = 1; i <= 6; i++) {
        code.push(this.otpCode[i]);
      }

      DibbleJs.showLoader();
      const data = {
        '#request': DibbleApi.api.accountVerifyOtpCode,
        factor_type: this.factorType,
        verification_code: code.join(''),
      };
      DibbleJs.callApiRequest(data, (responseData) => {
        if (DibbleApi.isResponseSuccess(responseData)) {
          DibbleJs.toastSuccessMessage(responseData.message);

          if (this.factorType === 'PHONE' && !this.userData.is_email_verified) {
            this.otpCode = {
              1: '',
              2: '',
              3: '',
              4: '',
              5: '',
              6: '',
            };
            this.isCodeSent = false;
            this.getUserData();
          } else {
            EventBus.$emit('reloadAuthStatus');
            this.closeModal();
          }
        } else {
          DibbleJs.toastErrorMessage(responseData.message);
        }
        DibbleJs.hideLoader();
      });
    },
    handleKeyDown(event, index) {
      if (event.key === 'Backspace') {
        this.otpCode[index] = ''

        if (index > 1) {
          this.$refs[`otp${index-1}`].focus()
        }

        return
      }

      if (!this.otpCode[index])
        return

      if (event.key !== 'Tab'
          && event.key !== 'ArrowRight'
          && event.key !== 'ArrowLeft'
      )
        event.preventDefault()

      if ((/^([0-9])$/).test(event.key)) {
          if (index !== 6)
              this.$refs[`otp${index+1}`].focus()
      }
    },
    _onRequestFailed(error) {
      this.isLoadingData = false
      DibbleJS.hideLoader();
      console.log(error)
      this.closeModal()
      DibbleJS.toastErrorMessage('Something wrong! can not load data');
    },
    closeModal() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
	.modal-content {
		min-width: 500px !important;
	}
	.modal-content, .modal-body {
		background: #ecf5f7 !important;
		border-radius: 60px !important;
		padding: 10px 20px;
	}
	.modal-header {
		display: flex !important;
		justify-content: space-between !important;
		align-items: center;
		padding: 10px 0px !important;
		border-bottom: 1.5px solid #1C5169;
		margin: 0 20px !important;
		.title-modal {
			font-family: 'Open Sans';
			font-style: normal;
			font-weight: 700;
			font-size: 22px;
			line-height: 22px;
			letter-spacing: 0.01em;
			color: #1C5169;
			margin-top: 0 !important;
		}
		button {
			border: none !important;
			outline: none !important;
			background: initial;
		}
	}
  .user-modal-content {
    max-height: 500px;
    overflow: scroll;
  }
  .btn-dialog.btn-sm {
    font-size: 14px;
    height: 40px;
  }
  .form-box.otp-input-wrap {
      box-shadow: 0px 12px 20px -16px #767676;
      /* -webkit-box-shadow: 0px 12px 20px -12px #767676; */
      -moz-box-shadow: -1px 7px 5px -2px rgba(191, 191, 191, 0.75);
      background: #e8eff1;
      padding-top: 14px;
  }
  .otp-input {
    width: 30px;
    height: 30px;
    border-radius: 5px;
    text-align: center;
    font-size: 25px;
    font-weight: 600;
  }
</style>
